import { tns as tinySlider } from "tiny-slider/src/tiny-slider";

const AUTOPLAY_TIMEOUT = 5000;
const NAV_IS_ACTIVE_CLASS = "is-active";

class Slider {
    constructor(options) {
        this.resumeAutoplayTimer = null;
        this.slider = tinySlider({
            items: 1,
            slideBy: "page",
            center: true,
            controls: false,
            autoplay: true,
            autoplayButtonOutput: false,
            onInit: Slider.toggleNavActiveClass,
            ...options
        });

        this.slider.events.on("transitionStart", Slider.toggleNavActiveClass);
        this.slider.events.on("indexChanged", () => {
            this.resumeAutoplay();
        });
    }

    static toggleNavActiveClass(info) {
        const { navItems, displayIndex } = info;
        [...navItems].forEach((navItem, navItemIndex) => {
            if (navItemIndex === displayIndex - 1) {
                navItem.classList.add(NAV_IS_ACTIVE_CLASS);
            } else {
                navItem.classList.remove(NAV_IS_ACTIVE_CLASS);
            }
        });
    }

    resumeAutoplay() {
        clearTimeout(this.resumeAutoplayTimer);
        this.resumeAutoplayTimer = setTimeout(() => this.slider.play(), AUTOPLAY_TIMEOUT);
    }
}

export { Slider };
